'use strict';

angular.module('mobile-apps')
	.factory('EntryMain', [
		'$rootScope',
		'$stateParams',
		'Languages',
		'FilesLanguageEntries',
		'Groups',
		'Tags',
		'TeamApps',
		'LanguageEntries',
		'MobileApps',
		'CacheDataLoad',
		'$q',
		function(
			$rootScope,
			$stateParams,
			Languages,
			FilesLanguageEntries,
			Groups,
			Tags,
			TeamApps,
			LanguageEntries,
			MobileApps,
			CacheDataLoad,
			$q
		) {

			var factory = {};

			factory.groups = {};
			factory.defaultGroup = undefined;
			factory.languages = {};
			factory.mobileApps = {};
			factory.entryKeyMap = {};
			factory.languageEntryMap = {};
			factory.groupLanguageEntryMap = {};
			factory.groupInfo = {};
			factory.allValues = {};


			factory.filterValues = {
				// Define the different filter-checkboxes and their order
				checkboxesOrder: [
					'emptyDraft',
					'emptyTranslation',
					'emptySource',
					'locked',
					'withIssues',
					'draftValueDiffer',
					'idSourceDiffer',
					'notEmptyDraft',
					'notEmptyTranslation',
					'notEmptySource',
					'notLocked',
					'withoutIssues',
					'draftValueIdentical',
					'idSourceIdentical'
				],
				checkboxes: {
					emptyDraft: {
						name: 'Empty Draft',
						filter: {
							draft: ''
						},
						notActive: [
							'notEmptyDraft'
						]
					},
					emptyTranslation: {
						name: 'Empty Translation',
						filter: {
							value: ''
						},
						notActive: [
							'notEmptyTranslation'
						]
					},
					emptySource: {
						name: 'Empty Source',
						filter: {
							sourceValue: ''
						},
						notActive: [
							'notEmptySource'
						]
					},
					locked: {
						name: 'Locked',
						filter: {
							locked: true
						},
						notActive: [
							'notLocked'
						]
					},
					withIssues: {
						name: 'With Issues',
						filter: {
							hasIssues: true
						},
						notActive: [
							'withoutIssues'
						]
					},
					draftValueDiffer: {
						name: 'Draft&Value Differ',
						filter: {
							draftValueDiffer: true
						},
						notActive: [
							'draftValueIdentical'
						]
					},
					idSourceDiffer: {
						name: 'Id&Source Differ',
						filter: {
							idSourceDiffer: true
						},
						notActive: [
							'idSourceIdentical'
						]
					},
					notEmptyDraft: {
						name: 'Not Empty Draft',
						filter: {
							_not: true,
							draft: ''
						},
						notActive: [
							'emptyDraft'
						]
					},
					notEmptyTranslation: {
						name: 'Not Empty Translation',
						filter: {
							_not: true,
							value: ''
						},
						notActive: [
							'emptyTranslation'
						]
					},
					notEmptySource: {
						name: 'Not Empty Source',
						filter: {
							_not: true,
							sourceValue: ''
						},
						notActive: [
							'emptySource'
						]
					},
					notLocked: {
						name: 'Not Locked',
						filter: {
							locked: false
						},
						notActive: [
							'locked'
						]
					},
					withoutIssues: {
						name: 'Without Issues',
						filter: {
							hasIssues: false
						},
						notActive: [
							'withIssues'
						]
					},
					draftValueIdentical: {
						name: 'Draft&Value Identical',
						filter: {
							draftValueDiffer: false,
							isUnTranslated: false,
							isTranslated: true,
							hasDraft: true
						},
						notActive: [
							'draftValueDiffer'
						]
					},
					idSourceIdentical: {
						name: 'Id&Source Identical',
						filter: {
							idSourceDiffer: false
						},
						notActive: [
							'idSourceDiffer'
						]
					}
				},
				dateFilters: [
					{
						from: 'changeDateFrom',
						to: 'changeDateTo',
						target: 'valueUpdatedAtTime'
					},
					{
						from: 'creationDateFrom',
						to: 'creationDateTo',
						target: 'valueCreatedAtTime'
					}
				]
			};



			// Define as which index the plural values should be saved
			factory.pluralValues = {
				'zero': 1000,
				'one':  1001,
				'two':  1002,
				'few':  1003,
				'many': 1004,
				'other': 1005
			};
			// Save the reverse values to have the accessible easily
			factory.pluralValuesReverse = {};
			Object.keys(factory.pluralValues).forEach(function(key) {
				factory.pluralValuesReverse[ factory.pluralValues[key] ] = key;
			});


			/**
			 * Loads a mobile app with all the related data
		     */
			factory.loadMobileApp = function (appId, forceRefresh, cb) {
				var me = this;
				return $q(function(resolve, reject) {
					async.parallel(
						[
							function(asyncCB) {
								me._fetchMobileApp(appId, forceRefresh, asyncCB);
							},
							function(asyncCB) {
								me._fetchInAppLanguages(appId, forceRefresh, asyncCB);
							},
							function(asyncCB) {
								me._fetchGroups(appId, forceRefresh, asyncCB);
							},
							function(asyncCB) {
								me._fetchDefaultGroup(appId, forceRefresh, asyncCB);
							}
						],
						function (err, result) {
							if (err) {
								reject(err);
								if (cb) {
									cb(err);
								}
								return;
							}


							var baseLanguage = {};
							for (var languageId in me.languages) {
								baseLanguage = me.languages[languageId];
								if (baseLanguage.name === me.mobileApps[appId].baseLanguage) {
									break;
								}
							}
							me.mobileApps[appId]._baseLanguage = baseLanguage;

							me.defaultGroup._id = _.find(me.groups, {name: me.defaultGroup.name})._id;

							resolve(result[0]);
							if (cb) {
								cb(null, result[0]);
							}
						}
					);
				});
			};


			/**
			 * Loads all the mobile apps of a team with all the related data
			 */
			factory.loadMobileAppsTeam = function(teamId, forceRefresh, cb) {
				var me = this;

				// Get all the apps the team has
				TeamApps.get({
					teamId: teamId
				}, function (mobileApps) {
					mobileApps = mobileApps || [];

					// Get the number of entries each app has
					var appLoadRequests = [];
					mobileApps.forEach(function(app) {
						appLoadRequests.push(function(asyncCB) {
							me._fetchMobileApp(app._id, forceRefresh, asyncCB);
						});
					});

					async.parallel(
						appLoadRequests,
						function (err, result) {
							if (err) {
								return cb(err);
							}

							cb(null, result);
						}
					);
				});
			};


			/**
			 * Loads a single entry of a mobile app with all related data
			 */
			factory.loadEntry = function(appId, languageId, entryId, cb) {
				var me = this;

				var returnPromise;
				if (!cb) {
					// If no callback is given we return a promise
					returnPromise = $q(function(resolve, reject){
						cb = function(err, data) {
							if (err) {
								return reject(err);
							}
							resolve(data);
						};
					});
				}

				var entryFiles = [];

				// Get the mobile App that we can check for the master language
				me.loadMobileApp(appId, false, function(err, mobileApp) {
					if (err) {
						return cb(err);
					}

					var queryFunctions = [
						// Get the entry
						function(asyncCB) {
							LanguageEntries.get(
								{
									mobileAppId: appId,
									languageId: languageId,
									entryId: entryId
								},
								function (result) {
									me.languageEntryMap[me.languages[languageId].name] = result;
									asyncCB(null, result);
								},
								function(error) {
									asyncCB(error);
								}
							);
						},
						function(asyncCB) {
							FilesLanguageEntries.query(
								{
									mobileAppId: appId,
									languageId: languageId,
									entryId: entryId
								},
								function (result) {
									entryFiles = result;
									asyncCB(null, result);
								},
								function(error) {
									asyncCB(error);
								}
							);
						}
					];


					var baseLanguage = me._getLanguageByName(mobileApp.baseLanguage);

					// If the current language is not the master language we
					// load also the values of the base language
					var isMasterLang = me.languages[languageId].name === mobileApp.baseLanguage;
					if (!isMasterLang) {
						var baseLanguageId = baseLanguage._id;
						queryFunctions.push(function(asyncCB) {
							var params = {
								mobileAppId: appId,
								languageId: baseLanguageId,
								entryId: entryId
							};
							LanguageEntries.get(params, function (result) {
								me.languageEntryMap[me.languages[baseLanguageId].name] = result;
								asyncCB(null, result);
							});
						});
					}


					async.parallel(
						queryFunctions,
						function (err, result) {
							if (err) {
								return cb(err);
							}

							// Add the queried files to the entry
							me.languageEntryMap[me.languages[languageId].name]._files = entryFiles;

							cb(null, true);
						}
					);

				});

				return returnPromise;
			};


			/**
			 * Loads the entries of a mobile app with all related data
			 */
			factory.loadEntries = function(appId, groupId, languageIds, refreshCache, cb) {
				var me = this;

				var returnPromise;
				if (!cb) {
					// If no callback is given we return a promise
					returnPromise = $q(function(resolve, reject){
						cb = function(err, data) {
							if (err) {
								return reject(err);
							}
							resolve(data);
						};
					});
				}

				// Get the mobile App that we can check for the master language
				me.loadMobileApp(appId, false, function(err, mobileApp) {
					if (err) {
						return cb(err);
					}

					if (!groupId) {
						groupId = me.defaultGroup._id;
					}

					var queryFunctions = [
						function(asyncCB) {
							// Always overwrite the data and do not cache it.
							// The reason is that it currently adds the value
							// data directly on the key-data.
							// That results in draft/value staying behind for
							// entries in different languages which do not have
							// any set.
							LanguageEntries.keyList(
								{
									mobileAppId: appId,
									groupId: groupId
								}, function (result) {
									me.entryKeyMap[groupId] = me.prepareEntries(result);

									asyncCB(null, me.entryKeyMap[groupId]);
								}, function(error) {
									asyncCB(error);
								}
							);
						}
					];


					// If none of the loaded languages is the base language we
					// load also the values of the base language
					var baseLanguage = me._getLanguageByName(mobileApp.baseLanguage);
					if (languageIds.indexOf(baseLanguage._id) === -1) {
						languageIds.push(baseLanguage._id);
					}

					// Query all the data of the different languages
					languageIds.forEach(function(languageId) {
						queryFunctions.push(function(asyncCB) {

							if (!me.groupLanguageEntryMap.hasOwnProperty(groupId)) {
								me.groupLanguageEntryMap[groupId] = {};
							}

							if (!refreshCache && me.groupLanguageEntryMap[groupId][languageId]) {

								// Data already exists
								asyncCB(null, me.groupLanguageEntryMap[groupId][languageId]);
							} else {
								// Data has to get loaded
								var refParams = {
									mobileAppId: appId,
									languageId: languageId,
									groupId: groupId,
									refreshCache: refreshCache
								};

								LanguageEntries.valueList(refParams, function (result) {
									me.groupLanguageEntryMap[groupId][languageId] = result;
									asyncCB(null, result);
								});
							}
						});
					});

					async.parallel(
						queryFunctions,
						function (err, result) {
							if (err) {
								return cb(err);
							}

							cb(null, true);
						}
					);

				});

				return returnPromise;
			};


			/**
			 * Returns the entry with a given id
			 */
			factory.getEntryById = function(id, groupId) {
				var me = this;

				var entries = me._getGroupEntries(groupId);

				for (var i in entries) {
					if (entries[i]._id === id) {
						return entries[i];
					}
				}

				return undefined;
			};


			/**
			 * Returns the entry with a given key
			 */
			factory.getEntryByKey = function(key, groupId) {
				var me = this;

				var entries = me._getGroupEntries(groupId);

				for (var i in entries) {
					if (entries[i].key === key) {
						return entries[i];
					}
				}

				return undefined;
			};


			factory._getGroupEntries = function(groupId) {
				var me = this;

				if (!groupId && me.defaultGroup) {
					groupId = me.defaultGroup._id;
				}

				if (!me.entryKeyMap.hasOwnProperty(groupId)) {
					return [];
				}

				return me.entryKeyMap[groupId];
			};


			factory._getHiddenEntryDescIdByKey = function(key) {
				var me = this;

				if (!me.allValues.hasOwnProperty(key)) {
					return [];
				}

				return me.allValues[key]._id;
			};


            factory.getHiddenEntryDescByKey = function(key) {
                var me = this;

                if (!me.allValues.hasOwnProperty(key)) {
                    return [];
                }

                return me.allValues[key];
            };


			factory._fetchDefaultGroup = function (appId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(appId, callback) {
					Groups.defaultGroup({
						mobileAppId: appId
					}, function (data) {
						return callback(null, data);
					}, function (err) {
						return callback(err);
					});
				};

				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'appDefaultGroup', appId, forceRefresh,
					function(err, defaultGroup) {
						if (err) {
							return cb(err);
						}

						me.defaultGroup = defaultGroup;
						return cb(null, me.defaultGroup);
					}
				);

			};



			factory._fetchGroups = function (appId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(appId, callback) {
					Groups.list({
						mobileAppId: appId
					}, function (data) {
						return callback(null, data);
					}, function (err) {
						return callback(err);
					});
				};


				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'appGroups', appId, forceRefresh,
					function(err, groupsData) {
						if (err) {
							me.groups = {};
							return cb(err);
						}

						me.groups = {};
						groupsData.forEach(function(groupData) {
							me.groups[groupData._id] = groupData;
						});

						return cb(null, me.groups);
					}
				);
			};



			factory._fetchMobileApp = function (appId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(appId, callback) {
					MobileApps.get({
						mobileAppId: appId
					}, function (data) {
						return callback(null, data);
					}, function (err) {
						return callback(err);
					});
				};


				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'mobileApp', appId, forceRefresh,
					function(err, mobileApp) {
						if (err) {
							me.mobileApps[appId] = {};
							return cb(err);
						}

						me.mobileApps[appId] = mobileApp;
						return cb(null, mobileApp);
					}
				);
			};



			factory._fetchInAppLanguages = function(appId, forceRefresh, cb) {
				var me = this;

				// Function which loads not cached data from database
				var getModelData = function(appId, callback) {
					Languages.query(
						{
							mobileAppId: appId
						},
						function success(languagesArray) {
							callback(null, languagesArray);
						}, function failure(err) {
							callback(err);
						}
					);
				};


				// Get data from Cache or Database depending on if data is
				// already available and if forceRefresh is set
				CacheDataLoad.getData(getModelData, 'appLanguages', appId, forceRefresh,
					function(err, languagesArray) {
						me.languages = {};

						if (err) {
							return cb(err);
						}

						languagesArray.forEach(function(languageData) {
							me.languages[languageData._id] = languageData;
						});
						return cb(null, me.languages);
					}
				);
			};


			factory.refreshEntries = function () {
				var me = this;

				me.entryKeyMap = {};
				me.groupLanguageEntryMap = {};
			};



			factory._getLanguageByName = function(languageName) {
				var me = this;

				for (var languageId in me.languages) {
					if (me.languages[languageId].name === languageName) {
						return me.languages[languageId];
					}
				}

				return undefined;
			};



			/**
			 * The plural index values get saved as integers. This function
			 * converts them back into the actual values
			 */
			factory.getEntryPluralIndex = function(index) {
				var me = this;

				if (index > 999) {
					index = me.pluralValuesReverse[index];
				}
				return index;
			};


			/**
			 * Prepares the given entry to be able to be group-sorted
			 */
			factory.prepareEntry = function(entry) {
				var me = this;

				me.allValues[entry.key] = entry;

				var keyInfo = entry.key.match(/(.*)\[(zero|one|two|few|many|other|\d+)\]$/);
				//var keyInfo = entry.key.match(/(.*)\[(\d+)\]$/);
				if (keyInfo) {
					entry._sortKey = keyInfo[1];
					if (isNaN(keyInfo[2])) {
						// Is a plural
						if (me.pluralValues.hasOwnProperty(keyInfo[2])) {
							entry._sortIndex = me.pluralValues[keyInfo[2]];
						}
					} else {
						// Is an array
						entry._sortIndex = parseInt(keyInfo[2]);
					}

					if (!me.groupInfo.hasOwnProperty(entry._sortKey)) {
						me.groupInfo[ entry._sortKey ] = {
							indexValues: [],
							sortValues: {}
						};
					}
					me.groupInfo[ entry._sortKey ].indexValues.push( entry._sortIndex );
				} 
				else if (entry.link) {
					entry._sortKey = entry.key;

					if (entry.link === entry.key) {
						if (!me.groupInfo.hasOwnProperty(entry._sortKey)) {
							me.groupInfo[ entry._sortKey ] = {
								indexValues: [],
								linkEntries: true,
								sortValues: {}
							};
						}
					}
				} 
				else {
					entry._sortKey = entry.key;
				}
			};


			/**
			 * Prepares the given entries to be able to be group-sorted
			 */
			factory.prepareEntries = function(data) {
				var me = this;
				if (!data) {
					return data;
				}

				// Reset the cache and the variable which holds all entries
				// for easy access
				me.groupInfo = {};
				me.allValues = {};

				// Go through each of the entries and add the needed properties
				data.forEach(function(entry) {
					me.prepareEntry(entry);
				});

				for (var key in me.groupInfo) {
					var groupInfo = me.groupInfo[ key ];

					if (groupInfo.linkEntries) {
						// If it's a linked group, show only one entry
						var parentEntry = me.allValues[key];
						parentEntry._sortFirst = true;

						for (var i = 0; i < parentEntry.linkedKeys.length; i++) {
							me.allValues[parentEntry.linkedKeys[i]]._hide = true;
						}
					}
					else {
						// Sort all the indexes because the order is important for some
						// of the sort options
						groupInfo.indexValues.sort(function(a, b){return a - b;});

						// Mark the first entry as such to display it correctly in view
						var firstIndex = groupInfo.indexValues[0];
						firstIndex = me.getEntryPluralIndex(firstIndex);
						var testKey = key + '[' + firstIndex + ']';
						me.allValues[testKey]._sortFirst = true;
					}
				}

				// Hide the entries that have been linked together
				return data.filter(function(entry, index, arr) {
					return (!entry._hide);
				});
			};



			/**
			 * Resets the cache for the entry with the given id
			 */
			factory.resetCachedSortValues = function(id) {
				var me = this;

				if (!me.allValues.hasOwnProperty(id)) {
					return;
				}

				if (!me.allValues[id].hasOwnProperty('_sortKey')) {
					return;
				}

				var key = me.allValues[id]._sortKey;
				if (!key || !me.groupInfo.hasOwnProperty(key)) {
					return;
				}

				me.groupInfo[key].sortValues = {};
			};



			/**
			 * Gets the base value for a grouped entry to be displayed as group
			 */
			factory._getArrayEntriesValue = function(key, propertyName, defaultValue) {
				var me = this;

				// Check if we have information about that group. If not it
				// does not exist and we can simply ignore it.
				if (!me.groupInfo.hasOwnProperty(key)) {
					return undefined;
				}

				var groupInfo = me.groupInfo[key];

				// Check if the value is already cached so that we do not have
				// to look it up again
				if (groupInfo.sortValues.hasOwnProperty(propertyName)) {
					return groupInfo.sortValues[propertyName];
				}

				// Value is not cached yet so we have to look it up.

				var returnValue;
				if (propertyName === 'valueUpdatedAt' || propertyName === '_id') {
					// Find the entry of the group which has the earliest/latest date
					var entryValues = [];
					groupInfo.indexValues.forEach(function(index) {

						index = me.getEntryPluralIndex(index);

						var testKey = key + '[' + index + ']';
						if (me.allValues[testKey][propertyName]) {
							var value = me.allValues[testKey][propertyName];

							if (propertyName === 'valueUpdatedAt') {
								// Create a milliseconds-time from date
								value = new Date(value).getTime();
							} else {
								// Will be "_id"
								// Create a milliseconds-time from MongoDB-id
								value = new Date(parseInt(value.substring(0, 8), 16) * 1000).getTime();
							}

							entryValues.push(value);
						}
					});

					if (entryValues.length !== 0) {
						if (propertyName === 'valueUpdatedAt') {
							// We want to get the latest date
							returnValue = Math.max.apply( Math, entryValues ).toString();
						} else if (propertyName === '_id') {
							// We want to get the earliest date
							returnValue = Math.min.apply( Math, entryValues ).toString();
						}
					}
				} else if (['draft', 'sourceValue', 'value'].indexOf(propertyName) !== -1) {
					// Find the first entry of the group which has a value set
					for (var i=0;i<groupInfo.indexValues.length;i++) {
						var index = groupInfo.indexValues[i];
						index = me.getEntryPluralIndex(index);
						var testKey = key + '[' + index + ']';
						if (me.allValues[testKey][propertyName]) {
							// A value got found so use it and stop search
							returnValue = me.allValues[testKey][propertyName];
							break;
						}
					}
				}

				if (returnValue === undefined) {
					// If no value could be found
					returnValue = defaultValue + key;
				} else {
					// We add the key to the return value to make sure
					// that they are no identical values for different groups
					// which would mess up the grouping in the view.
					returnValue = returnValue + key;
				}

				// Cache the found value that the look up is faster the next time
				me.groupInfo[key].sortValues[propertyName] = returnValue;

				return returnValue;
			};



			/**
			 * Takes the given filterValues and converts it to a finished query
			 */
			factory.convertToFilterQuery = function (filterValues) {
				var me = this;
				var filterTerms = [];
				// Add checkbox values
				Object.keys(me.filterValues.checkboxes).forEach(function(key) {
					var checkboxData = me.filterValues.checkboxes[key];
					var filterValue = filterValues[key];
					if (filterValue === true) {
						filterTerms.push(checkboxData.filter);
					}
				});

				// Add user-filter
				var lastUserChangedId = filterValues.lastUserChanged.id;
				if (lastUserChangedId !== 'any') {
					filterTerms.push({
						valueUser: lastUserChangedId
					});
				}

				// Add status-filter
				var statusId = filterValues.status.id;
				if (statusId !== 'any') {
					if (statusId === 'none') {
						filterTerms.push({
							_not: true,
							status: [1, 2, 3, 4]
						});
					} else {
						filterTerms.push({
							status: parseInt(statusId)
						});
					}
				}

				// Add the different date-filters
				me.filterValues.dateFilters.forEach(function(dateFilter) {
					var changeDateFilter = {};
					if (filterValues.hasOwnProperty(dateFilter.from) && filterValues[dateFilter.from]) {
						changeDateFilter.from = new Date(filterValues[dateFilter.from]).getTime();
					}
					if (filterValues.hasOwnProperty(dateFilter.to) && filterValues[dateFilter.to]) {
						// Add another day to the time that the filter works like
						// expected else it does not include the selected day
						changeDateFilter.to = new Date(filterValues[dateFilter.to]).getTime() + 86400000;
					}
					if (Object.keys(changeDateFilter).length !== 0) {
						var filter = {};
						filter[dateFilter.target] = changeDateFilter;
						filterTerms.push(filter);
					}
				});

				//Add metadata filter
				if(filterValues.metadata && (filterValues.metadata.value || filterValues.metadata.operator === 'Has any value' || filterValues.metadata.operator === 'Has no value')){
					var metadataFilter = { 
						key: filterValues.metadata.key.fieldName, 
						operator: filterValues.metadata.operator, 
						value: filterValues.metadata.value
					};
					filterTerms.push({
						metadata: metadataFilter
					});
				}

				// Prepare the filter to be returned
				var filter = {};
				if (filterTerms.length === 1) {
					// If there is just value to filter for we can return only that one
					filter = filterTerms[0];
				} else if (filterTerms.length !== 0) {
					// If there are multiple values return all of them combined
					filter = {
						_join: 'AND',
						terms: filterTerms
					};
				}

				return filter;
			};

			return factory;
		}
	]);
